import { VITE_PAGARME_PUBLIC_KEY } from "@repo/lib";

interface PagarmeErrorResponse {
  errors?: Record<string, string>;
}

interface PagarmeTokenResponse {
  id: string;
}

export const getEncodedCardV5 = async (
  cardNumber: string,
  cardName: string,
  cardExpiry: string,
  cardCvc: string,
): Promise<string> => {
  const [expMonth, expYear] = [cardExpiry.slice(0, 2), cardExpiry.slice(2)];
  const body = {
    card: {
      number: cardNumber.replace(/\s/g, ""),
      holder_name: cardName,
      exp_month: expMonth,
      exp_year: expYear,
      cvv: cardCvc,
    },
    type: "card",
  };

  const res = await fetch(
    `https://api.pagar.me/core/v5/tokens?appId=${VITE_PAGARME_PUBLIC_KEY}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    },
  );

  if (!res.ok) {
    const jsonError = (await res.json()) as PagarmeErrorResponse;
    const errors = jsonError.errors;
    throw new Error(
      `Falha ao tokenizar cartão (v5) - ${res.status} ${res.statusText} ${JSON.stringify(errors)}`,
    );
  }

  const data = (await res.json()) as PagarmeTokenResponse;
  return data.id;
};
